if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      console.log(event);
      console.log(event.detail);
      console.log(event.detail.currentElement);
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

/* ===== Mobile lightbox + desktop hover zoom (bundled; avoids new-asset CDN miss) ===== */
(function () {
  var MOBILE_MQ = '(max-width: 749px)';
  var MAX_ZOOM = 3.5;
  var MIN_ZOOM = 1;
  var SWIPE_THRESHOLD = 50;

  function touchDistance(a, b) {
    var dx = a.clientX - b.clientX;
    var dy = a.clientY - b.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  class ProductModal extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.zoomScale = 1;
      this.panX = 0;
      this.panY = 0;
      this._pinchStartDist = 0;
      this._pinchStartScale = 1;
      this._panStartX = 0;
      this._panStartY = 0;
      this._panOriginX = 0;
      this._panOriginY = 0;
      this._swipeStartX = 0;
      this._swipeStartY = 0;
      this._swiping = false;
      this._pinching = false;
      this._lastTap = 0;
      this._onKey = this._onKey.bind(this);
      this._onClose = function () { this.hide(); }.bind(this);
      this._onPrev = function (e) { e.stopPropagation(); this.step(-1); }.bind(this);
      this._onNext = function (e) { e.stopPropagation(); this.step(1); }.bind(this);
      this._onBackdrop = function (event) {
        if (event.target === this || event.target === this.stage) this.hide();
      }.bind(this);
      this._onTouchStart = this._onTouchStart.bind(this);
      this._onTouchMove = this._onTouchMove.bind(this);
      this._onTouchEnd = this._onTouchEnd.bind(this);
    }

    connectedCallback() {
      if (!this._listenersBound) {
        this._listenersBound = true;
        this.closeBtn = this.querySelector('[data-lightbox-close]');
        this.prevBtn = this.querySelector('[data-lightbox-prev]');
        this.nextBtn = this.querySelector('[data-lightbox-next]');
        this.counterEl = this.querySelector('[data-lightbox-counter]');
        this.stage = this.querySelector('[data-lightbox-stage]');
        this.content = this.querySelector('[data-lightbox-content]');
        if (this.closeBtn) this.closeBtn.addEventListener('click', this._onClose);
        if (this.prevBtn) this.prevBtn.addEventListener('click', this._onPrev);
        if (this.nextBtn) this.nextBtn.addEventListener('click', this._onNext);
        this.addEventListener('click', this._onBackdrop);
        if (this.stage) {
          this.stage.addEventListener('touchstart', this._onTouchStart, { passive: false });
          this.stage.addEventListener('touchmove', this._onTouchMove, { passive: false });
          this.stage.addEventListener('touchend', this._onTouchEnd, { passive: false });
          this.stage.addEventListener('touchcancel', this._onTouchEnd, { passive: false });
        }
      }
      // Sibling AJAX moves modal to body; remove stale same-id modals before re-append
      if (this.id) {
        Array.prototype.forEach.call(document.querySelectorAll('product-modal'), function (el) {
          if (el !== this && el.id === this.id) el.remove();
        }, this);
      }
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }

    get slides() {
      return Array.from(this.querySelectorAll('[data-lightbox-slide]'));
    }

    get activeSlide() {
      return this.slides[this.currentIndex] || null;
    }

    get activeImg() {
      var slide = this.activeSlide;
      return slide ? slide.querySelector('img') : null;
    }

    isMobile() {
      return window.matchMedia(MOBILE_MQ).matches;
    }

    show(opener) {
      if (!this.isMobile()) return false;
      this.openedBy = opener;
      var mediaId = opener && opener.getAttribute('data-media-id');
      var slides = this.slides;
      if (!slides.length) return false;
      var index = 0;
      if (mediaId) {
        var found = slides.findIndex(function (slide) {
          return String(slide.getAttribute('data-media-id')) === String(mediaId);
        });
        if (found >= 0) index = found;
      }
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      this.goTo(index);
      window.addEventListener('keyup', this._onKey);
      if (typeof trapFocus === 'function') {
        try { trapFocus(this, this.querySelector('[role="dialog"]') || this.closeBtn || this); } catch (e) {}
      }
      return true;
    }

    hide() {
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      this._resetZoom();
      window.removeEventListener('keyup', this._onKey);
      if (typeof removeTrapFocus === 'function' && this.openedBy) {
        try { removeTrapFocus(this.openedBy); } catch (e) {}
      }
    }

    _onKey(event) {
      var code = event.code || '';
      if (code === 'Escape') this.hide();
      if (code === 'ArrowLeft') this.step(-1);
      if (code === 'ArrowRight') this.step(1);
    }

    step(delta) {
      var slides = this.slides;
      if (!slides.length) return;
      this.goTo((this.currentIndex + delta + slides.length) % slides.length);
    }

    goTo(index) {
      var slides = this.slides;
      if (!slides.length) return;
      this.currentIndex = index;
      this._resetZoom();
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('active', active);
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('hidden');
          slide.scrollTop = 0;
          slide.scrollLeft = 0;
        } else {
          slide.setAttribute('hidden', '');
        }
      });
      if (this.counterEl) this.counterEl.textContent = index + 1 + ' / ' + slides.length;
    }

    _onTouchStart(event) {
      if (!this.hasAttribute('open')) return;
      var touches = event.touches;
      if (touches.length === 2) {
        this._pinching = true;
        this._swiping = false;
        this._pinchStartDist = touchDistance(touches[0], touches[1]);
        this._pinchStartScale = this.zoomScale;
        event.preventDefault();
        return;
      }
      if (touches.length === 1) {
        this._swipeStartX = touches[0].clientX;
        this._swipeStartY = touches[0].clientY;
        this._panStartX = touches[0].clientX;
        this._panStartY = touches[0].clientY;
        this._panOriginX = this.panX;
        this._panOriginY = this.panY;
        this._swiping = this.zoomScale <= 1.05;
        this._pinching = false;
      }
    }

    _onTouchMove(event) {
      if (!this.hasAttribute('open')) return;
      var touches = event.touches;

      if (touches.length === 2 && this._pinchStartDist > 0) {
        event.preventDefault();
        this._pinching = true;
        this._swiping = false;
        var dist = touchDistance(touches[0], touches[1]);
        var next = this._pinchStartScale * (dist / this._pinchStartDist);
        this.zoomScale = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, next));
        if (this.zoomScale <= 1.02) {
          this.zoomScale = 1;
          this.panX = 0;
          this.panY = 0;
        }
        this._applyTransform();
        return;
      }

      if (touches.length === 1 && this.zoomScale > 1.05) {
        event.preventDefault();
        this._swiping = false;
        this.panX = this._panOriginX + (touches[0].clientX - this._panStartX);
        this.panY = this._panOriginY + (touches[0].clientY - this._panStartY);
        this._clampPan();
        this._applyTransform();
      }
    }

    _onTouchEnd(event) {
      if (!this.hasAttribute('open')) return;

      // Double-tap to toggle zoom inside frame
      if (!this._pinching && event.changedTouches && event.changedTouches.length === 1) {
        var now = Date.now();
        if (now - this._lastTap < 280) {
          event.preventDefault();
          this._toggleZoomAt(event.changedTouches[0]);
          this._lastTap = 0;
          this._swiping = false;
          this._pinching = false;
          return;
        }
        this._lastTap = now;
      }

      if (this._pinching) {
        this._pinching = false;
        this._pinchStartDist = 0;
        if (this.zoomScale < 1.08) this._resetZoom();
        else this._clampPan();
        this._applyTransform();
        return;
      }

      if (this._swiping && this.zoomScale <= 1.05 && event.changedTouches && event.changedTouches.length) {
        var t = event.changedTouches[0];
        var dx = t.clientX - this._swipeStartX;
        var dy = t.clientY - this._swipeStartY;
        if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy) * 1.2) {
          event.preventDefault();
          this.step(dx < 0 ? 1 : -1);
        }
      }

      this._swiping = false;
      this._pinching = false;
    }

    _toggleZoomAt(touch) {
      var img = this.activeImg;
      if (!img) return;
      if (this.zoomScale > 1.05) {
        this._resetZoom();
        return;
      }
      var rect = img.getBoundingClientRect();
      var ox = ((touch.clientX - rect.left) / rect.width) * 100;
      var oy = ((touch.clientY - rect.top) / rect.height) * 100;
      this.zoomScale = 2.4;
      this.panX = 0;
      this.panY = 0;
      img.style.transformOrigin = ox + '% ' + oy + '%';
      this._applyTransform(true);
    }

    _clampPan() {
      var slide = this.activeSlide;
      var img = this.activeImg;
      if (!slide || !img || this.zoomScale <= 1) {
        this.panX = 0;
        this.panY = 0;
        return;
      }
      var maxX = (slide.clientWidth * (this.zoomScale - 1)) / 2;
      var maxY = (slide.clientHeight * (this.zoomScale - 1)) / 2;
      this.panX = Math.max(-maxX, Math.min(maxX, this.panX));
      this.panY = Math.max(-maxY, Math.min(maxY, this.panY));
    }

    _applyTransform(keepOrigin) {
      var slide = this.activeSlide;
      var img = this.activeImg;
      if (!slide || !img) return;
      slide.classList.toggle('is-zoomed', this.zoomScale > 1.05);
      if (!keepOrigin) img.style.transformOrigin = 'center center';
      if (this.zoomScale <= 1.02) {
        img.style.transform = '';
      } else {
        img.style.transform = 'translate(' + this.panX + 'px, ' + this.panY + 'px) scale(' + this.zoomScale + ')';
      }
    }

    _resetZoom() {
      this.zoomScale = 1;
      this.panX = 0;
      this.panY = 0;
      this._pinchStartDist = 0;
      this.querySelectorAll('[data-lightbox-slide]').forEach(function (slide) {
        slide.classList.remove('is-zoomed');
        var img = slide.querySelector('img');
        if (img) {
          img.style.transform = '';
          img.style.transformOrigin = '';
        }
      });
    }
  }

  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', ProductModal);
  }

  function resolveModal(modalId) {
    if (!modalId) return null;
    var matches = document.querySelectorAll(modalId);
    return matches.length ? matches[matches.length - 1] : null;
  }

  function openFromButton(button) {
    if (!button || !window.matchMedia(MOBILE_MQ).matches) return;
    var modalId = button.getAttribute('data-modal');
    var modal = resolveModal(modalId);
    if (!modal) return;
    if (typeof modal.show !== 'function') {
      customElements.whenDefined('product-modal').then(function () {
        var ready = resolveModal(modalId);
        if (ready && typeof ready.show === 'function') ready.show(button);
      });
      return;
    }
    modal.show(button);
  }

  function cleanupOrphanProductModals() {
    var liveIds = {};
    document.querySelectorAll('[data-main-product-section] [data-product-lightbox-open]').forEach(function (btn) {
      var id = btn.getAttribute('data-modal');
      if (id) liveIds[id] = true;
    });
    // Prefer newest modal per id; drop detached duplicates left after AJAX
    var seen = {};
    Array.prototype.slice
      .call(document.querySelectorAll('product-modal.product-media-modal'))
      .reverse()
      .forEach(function (modal) {
        var key = modal.id ? '#' + modal.id : '';
        if (!key) return;
        if (seen[key] || (Object.keys(liveIds).length && !liveIds[key])) {
          modal.remove();
          return;
        }
        seen[key] = true;
      });
  }

  window.dunteryCleanupProductModals = cleanupOrphanProductModals;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-product-lightbox-open]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    openFromButton(button);
  }, true);

  document.addEventListener('product:ajax-loaded', function () {
    cleanupOrphanProductModals();
  });
})();

(function () {
  var DESKTOP_MQ = '(min-width: 750px)';
  var SCALE = 2;
  var observedGalleries = typeof WeakSet === 'function' ? new WeakSet() : null;

  function enableZoom(opener) {
    if (!opener || opener.dataset.zoomReady === 'true') return;
    opener.dataset.zoomReady = 'true';

    var media = opener.querySelector('.product__media');
    if (!media) return;
    media.classList.add('product-image-zoom');

    var img = media.querySelector('img');
    if (!img) return;

    var zoomSrc = img.getAttribute('data-zoom-src');
    if (zoomSrc && !img.dataset.zoomPreloaded) {
      img.dataset.zoomPreloaded = 'true';
      var preload = new Image();
      preload.src = zoomSrc;
      preload.onload = function () {
        img.dataset.hiresReady = 'true';
      };
    }

    var rafId = 0;
    var latestEvent = null;

    function applyZoom(event) {
      if (!window.matchMedia(DESKTOP_MQ).matches) return;
      var rect = media.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      var ratioX = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
      var ratioY = Math.min(1, Math.max(0, (event.clientY - rect.top) / rect.height));

      // Birdy-Grey style: origin top-left + scale + top/left pan inside overflow:hidden
      var left = -ratioX * (SCALE - 1) * rect.width;
      var top = -ratioY * (SCALE - 1) * rect.height;

      if (img.dataset.hiresReady === 'true' && zoomSrc && img.getAttribute('src') !== zoomSrc) {
        img.setAttribute('src', zoomSrc);
      }

      media.classList.add('is-zooming');
      img.style.transformOrigin = 'top left';
      img.style.transform = 'scale(' + SCALE + ')';
      img.style.left = left.toFixed(1) + 'px';
      img.style.top = top.toFixed(1) + 'px';
      img.style.width = '100%';
      img.style.height = '100%';
    }

    function onMove(event) {
      if (event.target.closest('.product__wishlist, .badge_tab-contain, .thumbnail-list')) return;
      latestEvent = event;
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = 0;
        if (latestEvent) applyZoom(latestEvent);
      });
    }

    function onLeave() {
      latestEvent = null;
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = 0;
      }
      media.classList.remove('is-zooming');
      img.style.transform = '';
      img.style.transformOrigin = '';
      img.style.left = '';
      img.style.top = '';
      img.style.width = '';
      img.style.height = '';
    }

    media.addEventListener('mousemove', onMove);
    media.addEventListener('mouseenter', onMove);
    media.addEventListener('mouseleave', onLeave);
  }

  function bindGallery(gallery) {
    gallery.querySelectorAll('.product__media-item .product__modal-opener--image').forEach(enableZoom);
  }

  function initZoom() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      bindGallery(gallery);
      if (observedGalleries) {
        if (observedGalleries.has(gallery)) return;
        observedGalleries.add(gallery);
      } else if (gallery.dataset.zoomObserved === 'true') {
        return;
      } else {
        gallery.dataset.zoomObserved = 'true';
      }
      new MutationObserver(function () {
        bindGallery(gallery);
      }).observe(gallery, { childList: true, subtree: true });
    });
  }

  window.dunteryInitProductZoom = initZoom;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZoom);
  } else {
    initZoom();
  }

  document.addEventListener('product:ajax-loaded', function () {
    window.requestAnimationFrame(initZoom);
  });
})();
